export const configConstants = {
  GET_ANNEES: "GET_ANNEES",
  GET_ANNEE: "GET_ANNEE",
};
